// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

// Components
import PageLoaderMain from './PageLoaderMain';

// Selectors
import { getIsLocalCacheHydrated } from '../../offline/cache/localCacheSelector';

// Styles
import './PageLoader.scss';

const mapStateToProps = createStructuredSelector({
    isLocalCacheHydrated: getIsLocalCacheHydrated,
});

// FIXME - Cleanup the local cache hydration check after feature flag is removed
const PageLoader = (props) => {
    const { isLocalCacheHydrated } = props;

    return (
        <div className="PageLoader">
            <div className="WorkspaceWrapper">
                <header className="AppHeader">
                    <div className="WorkspaceToolsHeader header-tools" />
                </header>
                <div className="Workspace">
                    <div className="workspace-positioner ">
                        <div id="toolbar" className="Toolbar" />
                        {!isLocalCacheHydrated && <PageLoaderMain {...props} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

PageLoader.propTypes = {
    isLocalCacheHydrated: PropTypes.bool,
};

export default connect(mapStateToProps)(PageLoader);
